module.exports = __webpack_public_path__ + "videos/home-53-hero_9x16_en.7f12746.mp4";